import { render, staticRenderFns } from "./anten_modal.vue?vue&type=template&id=1bee2451"
import script from "./anten_modal.vue?vue&type=script&lang=js"
export * from "./anten_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports